import Icon from "@material-ui/icons/Person";
import LevelGroupsCreate from "./LevelGroupsCreate";
import LevelGroupsEdit from "./LevelGroupsEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "levelGroups",
  edit: LevelGroupsEdit,
  create: LevelGroupsCreate,
  icon: Icon,
};
